import { useQuery } from "@tanstack/react-query";
import entityRepository from "@/repository/entityRepository";


const getData = async (agentId?: number) => {
    if (!agentId) {
        return [];
    }
    const res = await entityRepository.getTags(agentId);
    return res.data?.data || [];
};

export const useEntityTags = (agentId?: number) => {
    return useQuery<string[]>({
        queryKey: ['entity-tags', 'agent', agentId],
        queryFn: async () => getData(agentId),
        retry: false
    });
};
